<template>
    <DModal
        :title="__('customers.activation_modal.title')"
        :message="contract.billed_until_date === null ? '' : __('customers.activation_modal.message')"
        is-confirm
        is-error
        :show="showModal"
        :is-awaiting-validation="true"
        @confirm="activateConfirm"
        @close="$emit('close-modal')"
    >
        <div
            v-if="contract.billed_until_date === null"
            style="padding: 20px"
        >
            <DRow
                style="margin-top: 16px;"
            >
                <DCol>
                    <DSelect
                        id="start_date_type"
                        :label="__('customers.activation_modal.select_start_date_label')"
                        add-label-classes="required"
                        :options="contractStartDates"
                        :placeholder="__('customers.activation_modal.select_start_date_placeholder')"
                        @update:value="setContractStartDate"
                    />
                    <p
                        v-if="errors.start_date_label"
                        class="help-block text-danger"
                    >
                        {{ errors.start_date_label }}
                    </p>
                    <p
                        v-if="errors.contract_start_date && showManualStartDateInput === false"
                        class="help-block text-danger"
                    >
                        {{ errors.contract_start_date }}
                    </p>
                </DCol>
            </DRow>
            <DRow
                v-if="showManualStartDateInput"
                style="margin-top: 16px;"
            >
                <DCol>
                    <DDateFormatInput
                        id="start_date"
                        v-model="activationForm.contract_start_date"
                        :label="__('customers.activation_modal.manual_start_date_label')"
                        format="YYYY-MM-DD"
                        add-label-classes="required"
                        type="date"
                        @update:modelValue="setContractStartDate"
                    />
                    <p
                        v-if="errors.contract_start_date && activationForm.start_date_label ==='free_date_input'"
                        class="help-block text-danger"
                    >
                        {{ errors.contract_start_date }}
                    </p>
                </DCol>
            </DRow>
        </div>
    </DModal>
</template>

<script>
export default {
    name: 'ActivateContractModal',
    props: {
        contract: {
            type: Object,
            default: () => { return {} }
        },
        showModal: {
            type: Boolean,
            default: false
        },
        errorsData: {
            type: Object,
            default: () => { return {} }
        },
        redirectTo: {
            type: String,
            default: () => ''
        },
        filters: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['close-modal'],
    data () {
        return {
            activationForm: this.$inertia.form({
                start_date_label: null,
                contract_start_date: null
            }),
            showManualStartDateInput: false,
            errors: this.errorsData,
            contractStartDates: [
                {
                    value: '',
                    label: ''
                },
                {
                    value: 'today_date',
                    label: this.__('customers.activation_modal.select.today_date')
                },
                {
                    value: 'orig_start_date',
                    label: this.__('customers.activation_modal.select.orig_start_date')
                },
                {
                    value: 'free_date_input',
                    label: this.__('customers.activation_modal.select.free_input_date')
                }
            ]
        }
    },
    methods: {
        setContractStartDate (value) {
            this.activationForm.start_date_label = value
            this.showManualStartDateInput = false
            if (value === 'today_date') {
                this.activationForm.contract_start_date = new Date().toISOString().split('T')[0]
            } else if (value === 'orig_start_date') {
                this.activationForm.contract_start_date = this.contract.start_date
            } else {
                this.showManualStartDateInput = true
                this.activationForm.start_date_label = 'free_date_input'
            }
        },
        activateConfirm () {
            this.activationForm.post(this.$route('customers.customers.contracts.setActive', {
                customer: this.contract.customer_id,
                contract: this.contract.id,
                redirectTo: this.redirectTo,
                filters: this.filters
            }), {
                onSuccess: () => {
                    this.$emit('close-modal')
                },
                onError: (error) => {
                    this.errors = error
                }
            })
        }
    }
}
</script>

<style scoped>

</style>
